export const searchResults = [
  {
    imageUrl: "/destination/listing1.jpg",
    heading: "Kutiyattam",
  },
  {
    imageUrl: "/destination/listing2.jpg",
    heading: "Mohiniyattam",
  },
  {
    imageUrl: "/destination/listing1.jpg",
    heading: "Theyyam",
  },
  {
    imageUrl: "/destination/listing2.jpg",
    heading: "Oppana",
  },
  {
    imageUrl: "/destination/listing1.jpg",
    heading: "Parichamuttu kali",
  },
  {
    imageUrl: "/destination/listing2.jpg",
    heading: "Kalari",
  },
  {
    imageUrl: "/destination/listing2.jpg",
    heading: "Kalari",
  },
  {
    imageUrl: "/destination/listing2.jpg",
    heading: "Seethankan Thullal",
  },
  {
    imageUrl: "/destination/listing2.jpg",
    heading: "Kathakali",
  }
];

export const events = [
  {
    title: `Thrissur Pooram`,
    venue: `Thekkinkadu Maidanam`,
    conductingDate: "1",
    imgUrl: "discoverKerala/discover1.jpg",
    conductingMonth: "May",
    district: "Thrissur",
  },
  {
    title: `Nehru Trophy Boat Race`,
    venue: `Punnamada Lake`,
    conductingDate: "14",
    imgUrl: "discoverKerala/discover2.jpg",
    conductingMonth: "August",
    district: "Alappuzha",
  },
  {
    title: `Nishagandhi Dance & Music Festival`,
    venue: `Nishagandhi Auditorium`,
    conductingDate: "29",
    imgUrl: "discoverKerala/discover3.jpg",
    conductingMonth: "December",
    district: "TVM",
  },
];
